import type { Channel, ChildEntryPage } from "@/api_client";
import { ChildEntryForm } from "@/components/products/child/entry/ChildEntryForm";
import { ProductContainer } from "@/components/shared/productContainer/ProductContainer";
import { useEntryForWebComponents } from "../hooks/useEntryForWebComponents";

type ChildEntryProps = {
  backendHost?: string;
  appPathPrefix?: string;
  skipCart: boolean;
  channel?: Channel;
  language?: string;
};

export default function ChildEntry({
  backendHost,
  appPathPrefix,
  skipCart,
  channel,
  language,
}: Readonly<ChildEntryProps>) {
  const {
    isLoading,
    isSubmitting,
    submitEntryHandler,
    policyHolder,
    user,
    content,
  } = useEntryForWebComponents<ChildEntryPage>({
    productType: "child",
    backendHost,
    appPathPrefix,
    skipCart,
    channel,
    contentPageKey: "childEntryPage",
    language,
  });

  if (isLoading) return <ProductContainer.Loader />;

  return (
    <ChildEntryForm
      externalIsLoading={isSubmitting}
      externalSubmitHandler={submitEntryHandler}
      externalPolicyHolder={policyHolder}
      externalUser={user}
      externalContent={content}
    />
  );
}
